import styled from 'styled-components';

const StyledFlightPlanBlock = styled.div`
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const BoardingPassWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledInfoBlock = styled.div<{ $padding: 'small' | 'medium' }>`
  padding: ${(props) => (props.$padding === 'small' ? '1rem 2rem' : '2rem 3rem 3rem 3rem')};
  margin: 2rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  border: 1px solid ${(props) => props.theme.color.borderColor};
  border-radius: ${(props) => props.theme.radius.md};
`;

export { StyledFlightPlanBlock, BoardingPassWrapper, StyledInfoBlock };
